<div class="d-flex f-1 py-4 justify-content-center w-100">
  <img class="w-100" src="/assets/img/403.jpg" alt="unauthorized" />
</div>